<template>
  <div id="app">
    <Header />
    <main id="page-wrap">
      <transition name="show" mode="out-in">
        <router-view />
      </transition>
      <Footer />
      <Subscription />
      <Lgpd />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from './Header.vue'
import Footer from './Footer.vue'
import Subscription from './Subscription.vue'
import Lgpd from './Lgpd.vue'

export default {
  name: 'router',
  components: { Header, Footer, Subscription, Lgpd },
  computed: {
    ...mapState(['user'])
  },
  watch: {

  },
  async mounted () {

  }
}
</script>
